import { Box } from '@mui/material';
import LikesModal from 'components/LikesModal';
import { useState } from 'react';
import IosPinOutline from 'react-ionicons/lib/IosPinOutline';
import IosTimeOutline from 'react-ionicons/lib/IosTimeOutline';
import TimeAgo from 'react-timeago';
import { ProductType } from 'types/product.types';
import { UserType } from 'types/user.types';
import { LikeTarget } from 'utils/like-target';

import { LikeIcon } from '../../icons/like-icon';

interface ProductMetaInfoProps {
  product: ProductType;
  user: UserType;
  likeCount: number;
  isProductDeleted: boolean;
  formatter: any;
  productSlug: string;
  onLikeToggle?: (liked: boolean) => void;
}

export const ProductMetaInfo = ({
  product,
  user,
  likeCount,
  isProductDeleted,
  formatter,
  productSlug,
  onLikeToggle,
}: ProductMetaInfoProps): JSX.Element => {
  const [isLikesModalOpen, setLikesModalState] = useState(false);
  const likedProducts = user?.likedProducts || {};

  const openLikesModal = () => setLikesModalState(true);
  const closeLikesModal = () => setLikesModalState(false);

  return (
    <Box display="flex" flexDirection="row" marginTop="16px" fontSize="12px">
      <Box display="flex" flexDirection="row" gap="20px">
        {/* LIKES */}
        {!isProductDeleted && (
          <Box display="flex" alignItems="center" gap="8px" sx={{ cursor: 'pointer' }} onClick={openLikesModal}>
            <LikeIcon liked={likedProducts && likedProducts[product?.id]} />
            {likeCount || 0}
          </Box>
        )}

        {/* LIKES MODAL */}
        <LikesModal
          isOpen={isLikesModalOpen}
          isLiked={likedProducts && likedProducts[product?.id]}
          likeCount={likeCount}
          targetId={product?.id}
          likesTargetType={LikeTarget.PRODUCT}
          isSeller={product?.isOwner}
          currentUserId={user?.id}
          onClose={closeLikesModal}
          onLikeToggle={onLikeToggle}
          productOrShopSlug={productSlug}
        />

        {/* CREATED AT */}
        {product.createdAt && (
          <Box display="flex" alignItems="center" gap="8px">
            <IosTimeOutline />
            <TimeAgo date={product.firstPublishedAt || product.created_at} formatter={formatter} />
          </Box>
        )}

        {/* LOCATION */}
        {(product.location || product.address) && (
          <Box display="flex" alignItems="center" gap="8px">
            <IosPinOutline />
            {product.location}
            {product.location && product.address ? ', ' : ''}
            {product.address ? (product.address.length <= 80 ? product.address : product.address.substring(0, 80)) : ''}
            {product.address && product.address.length > 80 ? '...' : ''}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ProductMetaInfo;
